import { Directive, HostListener, Input, ViewContainerRef } from '@angular/core';
import { SharePopupComponent } from '../share-popup/share-popup.component';
import { take } from 'rxjs';

@Directive({
  selector: '[shareUrl]'
})
export class ShareDirective {

  @Input('shareUrl') shareUrl = null;
  @HostListener('click', ['$event']) onClick($event){
    this.showPopup();
  }

  constructor(
    private viewContainerRef: ViewContainerRef,
  ) {}

  showPopup() {
    const componentRef = this.viewContainerRef.createComponent(SharePopupComponent);
    componentRef.setInput('shareUrl', this.shareUrl);
    componentRef.instance.onClose.pipe(take(1)).subscribe(val => {
      componentRef.destroy();
    });

    const host = document.getElementById('host-position');
    host.insertBefore(componentRef.location.nativeElement, host.firstChild)
  }
  

}